import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ChevronRight, Printer } from "lucide-react";

const tabs = [
  { to: "/printlet", label: "نظرة عامة", end: true },
  { to: "/printlet/orders", label: "الطلبات" },
  { to: "/printlet/mappings", label: "الربط" },
  { to: "/printlet/catalog", label: "الكتالوج" },
  { to: "/printlet/events", label: "الأحداث" },
  { to: "/printlet/financials", label: "المالية" },
  { to: "/printlet/settings", label: "الإعدادات" },
];

export default function PrintletLayout() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 text-right" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 py-6 space-y-5">
        {/* Header */}
        <div>
          <button
            onClick={() => navigate("/dashboard")}
            className="text-sm text-slate-500 hover:text-slate-800 flex items-center gap-1 mb-3 transition"
          >
            <ChevronRight size={16} /> لوحة التحكم
          </button>
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-2xl bg-indigo-600 text-white shadow-sm shadow-indigo-200">
              <Printer size={24} />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Printlet</h1>
              <p className="text-slate-500 mt-0.5 text-sm">
                طباعة وتنفيذ خارجي — منفصل عن حالة طلب جراباتكم
              </p>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex flex-wrap gap-2 bg-white rounded-2xl border border-slate-200 p-2">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `px-4 py-2 rounded-xl text-sm font-medium transition ${
                  isActive
                    ? "bg-indigo-600 text-white shadow-sm shadow-indigo-200"
                    : "text-slate-600 hover:bg-slate-50 hover:text-indigo-600"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>

        {/* Content */}
        <Outlet />
      </div>
    </div>
  );
}